import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Add features, projects or `}<strong parentName="h2">{`whatever else`}</strong>{`.`}</h2>
    <ProjectCard title="Add Projects" link="https://stevenorechow.me/projects/" bg="linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%)" mdxType="ProjectCard">
 Add work that you're proud of, or a school project — <i>like this one!</i>
    </ProjectCard>
    <ProjectCard title="Add Details About You" link="https://stevenorechow.me/about/" bg="linear-gradient(0deg, #08AEEA 0%, #2AF598 100%)" mdxType="ProjectCard">
  Add places you've worked, what you worked on or your background.
    </ProjectCard>
    <ProjectCard title="Add Your Skills" link="https://stevenorechow.me/skills/" bg="linear-gradient(147deg, #FFE53B 0%, #FF2525 74%)" mdxType="ProjectCard">
 <dl>
  <dt><b>Add things you do well</b></dt> 
  <dd>Or how you can help people.</dd>
  </dl>
    </ProjectCard>
    <ProjectCard title="Add Quotes or Testimonials" link="https://stevenorechow.me/" bg="linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)" mdxType="ProjectCard">
  Add nice things people have said about your work, or your favourite quote. 
 
 <blockquote>
  <i>“'You miss 100% of the shots you don't take.' — Wayne Gretzky”</i> —Michael Scott
 </blockquote>
    </ProjectCard>
    <ProjectCard title="Articles" link="https://stevenorechow.me/articles/" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  Share posts or long-form thoughts. Really, you can add whatever you'd like.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      